'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import { Component } from 'react';
import styled from 'styled-components';
import UINavListItem from './UINavListItem';
import UIIcon from '../icon/UIIcon';
import classNames from 'classnames';
import { CALYPSO } from 'HubStyleTokens/colors';
import { NAV_ITEM_PADDING_RIGHT } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const NavListItem = styled(UINavListItem).withConfig({
  displayName: "UIFolderNavItem__NavListItem",
  componentId: "sc-2m19me-0"
})(["left:0;padding:8px;padding-right:", ";width:100%;&.private-folder-nav-item.private-nav-item{font-size:14px;}.private-icon{max-width:15px;margin-right:0.5em;}"], NAV_ITEM_PADDING_RIGHT);
export default class UIFolderNavItem extends Component {
  constructor(...args) {
    super(...args);
    this.getIcon = ({
      children,
      className,
      open,
      size
    } = {}) => {
      let icon = 'file';
      if (children != null) {
        icon = open ? 'folderOpen' : 'folder';
      }
      return /*#__PURE__*/_jsx(UIIcon, {
        className: classNames('private-folder-nav-item__icon', className),
        name: icon,
        size: size,
        color: CALYPSO
      });
    };
  }
  render() {
    const _this$props = this.props,
      {
        children,
        className
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(NavListItem, Object.assign({
      className: classNames('private-folder-nav-item', className),
      iconLeft: this.getIcon,
      hasChildren: children != null
    }, rest, {
      children: children
    }));
  }
}
UIFolderNavItem.displayName = 'UIFolderNavItem';
UIFolderNavItem.propTypes = Object.assign({}, UINavListItem.propTypes);
UIFolderNavItem.defaultProps = Object.assign({}, UINavListItem.defaultProps);